// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/weui/dist/style/weui.min.css
// module id = 1037
// module chunks = 0